"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PracticeEvolution() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="2249" id="practiceevolution" className="bg-background px-6 py-12 text-foreground lg:px-8 lg:py-20">
      <div className="mx-auto max-w-3xl">
        <div ref={eyebrowRef} className={`transition-all duration-700 ease-out ${eyebrowVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <h2 className="font-serif text-2xl font-bold leading-tight tracking-tight text-foreground md:text-[28px]">
            Relationships, Independence and Continued Trust
          </h2>
        </div>

        <div ref={contentRef} className={`mt-6 max-w-3xl space-y-5 transition-all duration-700 ease-out ${contentVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <p className="text-[17px] leading-[1.8] text-foreground/75">
            Over decades in practice, Morrie has learned the importance of
            maintaining an independent and durable practice.
          </p>

          <p className="text-[17px] leading-[1.8] text-foreground/75">
            A lawyer should be grateful to clients who return and continue to
            place their trust in the firm. At the same time, circumstances
            change. Clients may leave, relationships may end, and new matters
            arise.
          </p>

          <p className="text-[17px] leading-[1.8] text-foreground/75">
            For Morrie, continuing to develop professional relationships and new
            clients has always been part of sustaining the practice over time.
          </p>
        </div>
      </div>
    </section>;
}